import { Typography, Paper, Card, CardMedia } from "@mui/material";
import { AuthContextForm } from "components/AuthContext";

export default function TheStream() {
  return (
    <AuthContextForm>
      <Typography variant="h3" color="secondary.main" align="center">
        The Stream
      </Typography>
      <Paper sx={{ margin: "auto", padding: 4, maxWidth: 800 }}>
        <Card sx={{ borderRadius: 2, border: 0 }}>
          <CardMedia
            sx={{ height: "40vh", borderRadius: 2, border: 0 }}
            component="iframe"
            src="https://stream.campsomos.com/embed/video"
            title="Camp Somos Stream"
            allowFullScreen
          />
        </Card>
      </Paper>
    </AuthContextForm>
  );
}
